export default __webpack_public_path__ + "assets/icon-ocean_kelp.svg";